import { messageErreurMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [messageErreurMock];

export const erreurMock: SlugPage = {
  ...pageBase({
    title: 'Page Erreur',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
